import { Chakra } from "@airhelp/react-ui-components";
import PlanBox from "modules/common/components/PlanBox";
import IconLink from "modules/common/components/IconLink";
import { Stars } from "modules/common/components/Trustpilot/ReviewCard/Stars";
import { useTranslations, useLanguage } from "contexts/LocalizationContext";
import { AirhelpPlusItalicsLogo } from "styles/logos";
import getPageUrl from "utils/getPageUrl";
import usePricingPlanDetailsConfig from "./AhPlus.config";

const { ModalCloseButton, Flex, Box, Heading, Text, Grid } = Chakra;

const AhPlusModal = () => {
  const translations = useTranslations();
  const language = useLanguage();
  const { essential: essentialPlan, complete: completePlan } = usePricingPlanDetailsConfig();

  return (
    <Flex bg="primary.900" h={{ base: "full", lg: "calc(100vh - 32px)" }} flexDir="column" justify="center">
      <ModalCloseButton size="lg" zIndex={2} _hover={{}} _active={{}} />
      <Grid
        justifyContent="center"
        justifyItems="center"
        gap={7}
        templateColumns={{ base: "1fr", xl: "repeat(3, minmax(auto, 400px))" }}
        templateRows={{ base: "repeat(4, auto)", xl: "repeat(2, auto)" }}
        templateAreas={{
          base: "'header' 'essential' 'complete' 'description'",
          xl: "'header essential complete' 'description essential complete'",
        }}
        mb={12}
        px={{ base: 4, md: 10 }}
        py={10}
        pos="relative"
      >
        <Box color="white" gridArea="header">
          <AirhelpPlusItalicsLogo w="140px" h="auto" mb={4} d={{ base: "none", xl: "initial" }} />
          <Heading color="inherit" variant="h2" as="h2" textAlign={{ base: "center", xl: "left" }}>
            {translations("choose_plan_that_fits_your_needs")}
          </Heading>
        </Box>
        <Flex gridArea="description" justify="flex-end" flexDir="column" color="white" mt={{ base: 6, xl: 0 }}>
          <Box mb={{ base: 20, xl: 4 }} minH={{ xl: "250px" }}>
            <Stars />
            <Text color="inherit" mt={6} mb={4} fontSize="lg">
              {translations("airhelp_plus_review")}
            </Text>
            <Text color="inherit" fontWeight="bold" fontSize="md">
              {translations("airhelp_plus_reviewer")}
            </Text>
          </Box>
          {/* @ts-ignore */}
          <IconLink
            color="white"
            textDecor="underline"
            _visited={{}}
            _hover={{
              textDecor: "underline",
              color: "white",
            }}
            href={getPageUrl(language, "airhelpPlus")}
            text={translations("learn_more_about_ah_plus")}
            title={translations("learn_more_about_ah_plus")}
            prefetch
          />
        </Flex>
        {/* @ts-ignore */}
        <PlanBox gridArea="essential" planDetails={essentialPlan} />
        {/* @ts-ignore */}
        <PlanBox gridArea="complete" mt={{ xl: 12 }} planDetails={completePlan} />
      </Grid>
    </Flex>
  );
};

export default AhPlusModal;
